<template>
  <div>
    {{ tracking }}
    <a
      :href="url"
      target="_BLANK"
      style="color: white; text-decoration: none"
      v-if="url"
    >
      <v-icon small> mdi-truck-delivery </v-icon>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    tracking: String,
    url: String,
  },
}
</script>

<style></style>
